const pageJson = {
  ReEnterAddress: 'No, I want to re-enter my address.',
  noAddressFound: "I can't find my address.",
  doYouSeeYourAddress: 'Do you see your street address below ?',
  hereToHelp: "We're here to help.",
  enterAddress: 'Entering your address.',
  helpEnterAddress: 'Need help - Entering your address.',
  callUs: "Call us and we'll figure it out together.",
  lteSupportNo: '1.866.217.2223 for LTE and 5G Home Internet.',
  fiosSupportNo: '1.800.837.4966 for Fios Home Internet and High Speed Internet.',
  CheckSpelling: 'Check the spelling of your street address (e.g. John F Kennedy vs. JF Kennedy).',
  useCompleteAddress: 'Use the complete street address, even with words like "Drive, Avenue," etc. when it\'s in the name.',
  actualStreetAddress: "Make sure you're using an actual street address, not a P.O. box.",
  abbreviationBefore:
    'If your street has a direction before the street name (N, S, E, W, etc.), you should include the abbreviation before the street name (e.g., 240 S Graham Street).',
  abbreviationAfter:
    'If your street has a direction after the street name (N, S, E, W, etc.), you should include the abbreviation after the street name (e.g., 1729 First Street NW).',
  liveInApartment:
    'If you live in an apartment with several floors and apartments, please include your floor and apartment number (e.g., Flr 1 Apt C).',
  liveInbuilding:
    ' If you live in a building or complex with several different units, please include the building and/or apartment number (e.g., Bldg P Apt 21).',
  useSpaces: 'Use spaces between numbers and letters (e.g., Bldg P Apt 3 A).',
  reachExpert: 'Reach an expert',
  enterUnitNumber: 'Entering your unit type and/or number.',
  needHelpEnterUnitNumber: 'Need help - Entering your unit type and/or number.',
  helpEnterUnitNumber: 'help - Entering your unit type and/or number.',
  backCTA: 'Back',
  helpBackCTA: 'Need help - back.',
};

export { pageJson };
